import { useCastersContext } from "@/pages/caster/caster-data-entry-v2/CastersContext";
import { LostStrand } from "@/pages/caster/models/caster.models";
import { readLostStrandsFromPLC } from "@/pages/caster/repositories/ProductionRepository";
import { ResponseMESF } from "@dexteel/mesf-core";
import { Dispatch, SetStateAction } from "react";

interface Props {
	setLostStrandSelected: Function;
	setModalMode: Function;
	refreshData: Function;
	setError: Dispatch<SetStateAction<string | null>>;
}

export const useLostStrandActions = ({
	setLostStrandSelected,
	setModalMode,
	refreshData,
	setError,
}: Props) => {
	const { state, actions } = useCastersContext();

	const onEditButtonClick = (rowId: number) => {
		const lostStrand = state.lostStrands?.find(
			(row) => row.LostStrandId === rowId,
		);
		setLostStrandSelected(lostStrand);
		setModalMode("edit");
		actions.setRefreshInPause(true);
	};

	const onDeleteButtonClick = (rowId: number) => {
		const lostStrand = state.lostStrands?.find(
			(row) => row.LostStrandId === rowId,
		);
		setLostStrandSelected(lostStrand);
		setModalMode("delete");
		actions.setRefreshInPause(true);
	};

	const onCreateButtonClick = () => {
		setLostStrandSelected(null);
		setModalMode("create");
		actions.setRefreshInPause(true);
	};

	const readFromPLC = async () => {
		const processId = state?.processData?.ProcessId;
		if (processId) {
			const resp = await readLostStrandsFromPLC(processId);
			if (resp.ok) {
				refreshData();
				return { ok: true } as ResponseMESF;
			} else {
				setError(resp.message);
				return { ok: false, message: resp.message } as ResponseMESF;
			}
		} else {
			setError("Process not found");
			return { ok: false, message: "Process not found" } as ResponseMESF;
		}
	};

	return {
		onEditButtonClick,
		onDeleteButtonClick,
		onCreateButtonClick,
		readFromPLC,
	};
};
